export const getClassName = (base, classNames) => {
    let className = base;
    if (classNames && classNames.length) {
        if (typeof classNames === 'string') {
            classNames = classNames.trim().split(' ');
        }
        className += ' ' + classNames.filter((eachClassName) => !!eachClassName).map((eachClassName) => base + '--' + eachClassName).join(' ');
    }
    return className;
};